import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const Lazy = lazy(
  () => import(/* webpackChunkName: 'Ancillary Purchase' */ './index'),
);

export default function AncillaryPurchase() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <Lazy />
    </Suspense>
  );
}
